import { createAction, type QueuedAction } from "@/v2/hooks/useActionQueue";
import { apiCall, plural, type ActionDeps } from "./types";

export function deleteAction(ids: number[], deps: ActionDeps): QueuedAction {
	const idSet = new Set(ids);
	const rollback = deps.updateEntries((prev) =>
		prev.filter((e) => !idSet.has(e.id)),
	);
	const n = ids.length;

	return createAction({
		execute: () =>
			apiCall(deps, {
				endpoint: "/records/delete",
				method: "POST",
				body: { ids },
			}),
		rollback,
		toast: {
			loading: `Deleting ${n} ${plural(n)}…`,
			success: `Deleted ${n} ${plural(n)}`,
			error: "Failed to delete entries",
		},
		onSuccess: () => deps.refreshRecords(),
		onError: () => deps.refreshRecords(),
	});
}
